import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiService from '../../services/apiService';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const filterOptions = [
  { label: 'All', value: 1 },
  { label: 'Today', value: 2 },
  { label: 'Yesterday', value: 3 },
  { label: 'Last Week', value: 4 },
];

const UserView = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [userData, setUserData] = useState(null);
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(1);

  useEffect(() => {
    fetchUserDetails(); // Initial fetch
  }, []);

  const toggleExpand = (index) => {
    setExpandedCardIndex((prev) => (prev === index ? null : index));
  };

  const fetchUserDetails = async (filter_id = 1) => {
    try {
      // let res;
      // if (filter_id === 1) {
      //   res = await apiService.fetchData(`admin/user-details/${userId}`);
      // } else {
      //   res = await apiService.postData(`admin/user-details/${userId}`, { filter_id });
      // }
      const payload = { date_range: parseInt(filter_id) };
      const res = await apiService.postData(`admin/user-details/${userId}`, payload);

      if (!res.error && res.data?.length > 0) {
        setUserData(res.data[0]);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  const handleFilterChange = (e) => {
    const filterValue = Number(e.target.value);
    setSelectedFilter(filterValue);
    fetchUserDetails(filterValue);
  };

  if (!userData) return <div className="container mt-5">Loading...</div>;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  const {
    mobile,
    deviceId,
    card_count,
    cardlisteningTimeSeconds,
    radioListeningTimeSeconds,
    sleepListeningTimeSeconds,
    streak_count,
    cards = [],
  } = userData;

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">User Details</h4>
          <div className="d-flex align-items-center gap-2">
            <select className="form-select form-select-sm" value={selectedFilter} onChange={handleFilterChange}>
              {filterOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>
        </div>

        <div className="card-body">
          {/* Summary Info */}
          <div className="row mb-3">
            <div className="col-md-4 mb-2"><strong>Register Date:</strong> {formatDate(userData.created_at)}</div>
            <div className="col-md-4 mb-2"><strong>Last Login Date:</strong> {formatDate(userData.last_login_at)}</div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4 mb-2"><strong>Mobile:</strong> {mobile || 'N/A'}</div>
            <div className="col-md-4 mb-2"><strong>Device ID:</strong> {deviceId || 'N/A'}</div>
            <div className="col-md-4 mb-2"><strong>Total Card Count:</strong> {card_count ?? cards.length}</div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4 mb-2"><strong>Card Listening Time:</strong> {(cardlisteningTimeSeconds / 60).toFixed(1)} mins</div>
            <div className="col-md-4 mb-2"><strong>Radio Listening Time:</strong> {(radioListeningTimeSeconds / 60).toFixed(1)} mins</div>
            <div className="col-md-4 mb-2"><strong>Sleep Listening Time:</strong> {(sleepListeningTimeSeconds / 60).toFixed(1)} mins</div>
          </div>
          <div className="row mb-4">
            <div className="col-md-4 mb-2"><strong>Streak Count:</strong> {streak_count ?? 0}</div>
          </div>


          {/* Cards */}

<h5 className="mt-4">Cards</h5>
<table className="table table-bordered mt-2 mb-4">
  <thead className="table-light">
    <tr>
      <th>#</th>
      <th>Card Name</th>
      <th>Content Image</th>
      <th>Type</th>
    </tr>
  </thead>
  <tbody>
    {cards.length > 0 ? cards.map((card, i) => {
      const content = card.UserCardsToContentDetails || {};
      const isExpanded = expandedCardIndex === i;
      return (
        <React.Fragment key={i}>
          <tr>
            <td>{i + 1}</td>
            <td>
              <span
                style={{ cursor: 'pointer', color: '#007bff', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                onClick={() => toggleExpand(i)}
              >
                {content.title || 'N/A'}
                {isExpanded ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
              </span>
            </td>
            <td>
              {content.img ? (
                <img
                  src={apiService.getFullImageUrl(content.img)}
                  alt="Card"
                  style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }}
                />
              ) : 'N/A'}
            </td>
            <td>
              {content.content_type === 1
                ? 'Story'
                : content.content_type === 2
                ? 'Learning'
                : content.content_type === 3
                ? 'Song'
                : 'N/A'}
            </td>
          </tr>

          {isExpanded && (
  <tr>
    <td colSpan="5" style={{ padding: '20px' }}>
      {card.UserCardToChapters?.length > 0 ? (
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '10px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            padding: '15px 25px',
            maxHeight: '300px',
            overflowY: 'auto',
          }}
        >
          <h5 style={{ marginBottom: '10px', fontWeight: '700', color: '#444' }}>Chapters</h5>
          {card.UserCardToChapters.map((chapter, idx) => (
            <div
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 6px',
                borderBottom: idx !== card.UserCardToChapters.length - 1 ? '1px solid #eee' : 'none',
                transition: 'background-color 0.2s ease',
                cursor: 'default',
              }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <div style={{ flexBasis: '30px', fontWeight: '600', color: '#555' }}>{idx + 1}</div>
              <div style={{ flex: 1, fontWeight: '600', color: '#222' }}>
                {chapter.UserCardChapterToChapter?.title || 'N/A'}
              </div>
              <div style={{ width: '140px', textAlign: 'right', color: '#666', fontWeight: '500' }}>
                {((Number(chapter.duration) || 0) / 60).toFixed(1)} / {((Number(chapter.total_duration) || 0) / 60).toFixed(1)} min
              </div>
              <div
                style={{
                  width: '110px',
                  textAlign: 'center',
                  fontWeight: '700',
                  color: chapter.is_completed === 1 ? '#28a745' : '#dc3545',
                }}
              >
                {chapter.is_completed === 1 ? 'Completed' : 'Incomplete'}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-muted p-2">No chapters found for this card.</div>
      )}
    </td>
  </tr>
)}

        </React.Fragment>
      );
    }) : (
      <tr><td colSpan="4" className="text-center">No cards found.</td></tr>
    )}
  </tbody>
</table>


          <h5 className="mt-4">Sleep Items</h5>
<table className="table table-bordered mt-2 mb-4">
  <thead className="table-light">
    <tr>
      <th>#</th>
      <th>Sleep Name</th>
      <th>Time (Min)</th>
    </tr>
  </thead>
  <tbody>
    {userData.sleepChapterListening?.length > 0 ? userData.sleepChapterListening.map((item, i) => (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>{item.chapterName || 'N/A'}</td>
        <td>{((Number(item.totalSecondsListened) || 0) / 60).toFixed(1)}</td>
      </tr>
    )) : (
      <tr><td colSpan="3" className="text-center">No sleep data found.</td></tr>
    )}
  </tbody>
</table>

<h5 className="mt-4">Radio Items</h5>
<table className="table table-bordered mt-2">
  <thead className="table-light">
    <tr>
      <th>#</th>
      <th>Radio Name</th>
      <th>Time (Min)</th>
    </tr>
  </thead>
  <tbody>
    {userData.radioChapterListening?.length > 0 ? userData.radioChapterListening.map((item, i) => (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>{item.chapterName || 'N/A'}</td>
        <td>{((Number(item.totalSecondsListened) || 0) / 60).toFixed(1)}</td>
      </tr>
    )) : (
      <tr><td colSpan="3" className="text-center">No radio data found.</td></tr>
    )}
  </tbody>
</table>


{/* Top Favourite Cards */}
<h5 className="mt-4">Top Favourite Cards</h5>
<table className="table table-bordered mt-2 mb-4">
  <thead className="table-light">
    <tr>
      <th>#</th>
      <th>Card Name</th>
      <th>Content Image</th>
      <th>Type</th>
      <th>Completed Duration (Min)</th>
    </tr>
  </thead>
  <tbody>
    {userData.topFavouriteCards?.length > 0 ? userData.topFavouriteCards.slice(0, 3).map((card, i) => (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>{card.UserCardsToContentDetails?.title || 'N/A'}</td>
        <td>
          {card.UserCardsToContentDetails?.img ? (
            <img
              src={apiService.getFullImageUrl(card.UserCardsToContentDetails.img)}
              alt="Top Card"
              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }}
            />
          ) : 'N/A'}
        </td>
        <td>
          {card.UserCardsToContentDetails?.content_type === 1
            ? 'Story'
            : card.UserCardsToContentDetails?.content_type === 2
            ? 'Learning'
            : card.UserCardsToContentDetails?.content_type === 3
            ? 'Song'
            : card.UserCardsToContentDetails?.is_sleep === 1
            ? 'Sleep'
            : 'N/A'}
        </td>
        <td>{card.completed_duration ? (card.completed_duration / 60).toFixed(1) : '0.0'}</td>
      </tr>
    )) : (
      <tr><td colSpan="5" className="text-center">No top favourite cards found.</td></tr>
    )}
  </tbody>
</table>

        </div>
      </div>
    </div>
  );
};

export default UserView;
